var _excluded = ["ctaList", "dropdownRefs", "backLink"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useEffect, useRef, useState } from "react";
import BrandContext from "../../../../../../../contexts/BrandContext";
import IsDarkModeContext from "../../../../../../../contexts/IsDarkModeContext";
import OnColorContext from "../../../../../../../contexts/OnColorContext";
import useBreakpoint from "../../../../../../../hooks/useBreakpoint";
import { focusFirstElementInWrapper } from "../../../../../../../hooks/useFocusWrapper";
import { KeyboardEventKeys } from "../../../../../../../typings/types";
import replaceSpaceToDashAndLowerCase from "../../../../../../../utils/replaceSpaceToDashAndLowerCase";
import { spaceFactor } from "../../../../../../../utils/space";
import BreakpointVisibilityOrg from "../../../../../BreakpointVisibilityOrg";
import DispatchContext from "../../../../contexts/DispatchContext";
import StateContext from "../../../../contexts/StateContext";
import { ActionType } from "../../../../reducers/mainReducer";
import { horizontalPaddingSpaceOnDesktop } from "../../../common/DropdownOrg";
import { hugeBreakpointValue, navigationBackgroundOnDarkMode, navigationBackgroundOnMobile } from "../../../settings";
import NavigationCtaAtm, { paddingHorizontalSpaceOnHugeScreen } from "./NavigationCtaAtm";
import { NavigationList, BackLinkLi } from "./NavigationListOrg.styled";
function NavigationListOrg(_ref) {
  var ctaList = _ref.ctaList,
    dropdownRefs = _ref.dropdownRefs,
    backLink = _ref.backLink,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var brand = useContext(BrandContext);
  var _useContext = useContext(StateContext),
    navigationIndex = _useContext.navigationIndex,
    desktopDropdown = _useContext.desktopDropdown,
    markerLeftPosition = _useContext.markerLeftPosition,
    navigationListFocusIndex = _useContext.navigationListFocusIndex;
  var dispatch = useContext(DispatchContext);
  var ctaRefs = useRef([]);
  var timeoutRef = useRef(null);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isFirstAppear = _useState2[0],
    setIsFirstAppear = _useState2[1];
  var isHugeScreen = useBreakpoint(hugeBreakpointValue);
  var isNavigationCtaInactive = function isNavigationCtaInactive(index) {
    return navigationIndex !== null && navigationIndex !== index;
  };
  var handleCtaWithDropdownClick = function handleCtaWithDropdownClick(index, event) {
    return function () {
      var onCtaClick = ctaList[index].onClick;
      if (!isHugeScreen) {
        dispatch({
          type: ActionType.SET_NAVIGATION_ACTIVE,
          navigationIndex: index,
          markerLeftPosition: null,
          desktopDropdown: null
        });
      }
      if (onCtaClick && event) {
        onCtaClick(event);
      }
    };
  };
  var handleCtaWithoutDropdownClick = function handleCtaWithoutDropdownClick(index, event) {
    return function () {
      var onCtaClick = ctaList[index].onClick;
      dispatch({
        type: ActionType.SET_NAVIGATION_INACTIVE
      });
      if (onCtaClick) {
        onCtaClick(event);
      }
    };
  };
  var handleCtaMouseEnter = function handleCtaMouseEnter(index, event) {
    return function () {
      var onCtaMouseEnter = ctaList[index].onMouseEnter;
      if (isHugeScreen) {
        var dropdown = dropdownRefs.current[index];
        var timeoutId = window.setTimeout(function () {
          var cta = ctaRefs.current[index];
          if (cta) {
            var ctaLeft = cta.offsetLeft;
            var ctaPadding = paddingHorizontalSpaceOnHugeScreen * spaceFactor;
            var markerLeftPositionValue = ctaLeft + ctaPadding;
            if (dropdown) {
              var ctaHeight = cta.offsetHeight;
              var ctaTop = cta.offsetTop;
              var dropdownWidth = dropdown.offsetWidth;
              var dropdownHeight = dropdown.offsetHeight;
              var dropdownPadding = horizontalPaddingSpaceOnDesktop * spaceFactor;
              var dropdownAside = dropdown.children[0].children[1];
              var dropdownAsideHeight = dropdownAside ? dropdownAside.offsetHeight : 0;
              dispatch({
                type: ActionType.SET_NAVIGATION_ACTIVE,
                navigationIndex: index,
                markerLeftPosition: markerLeftPositionValue,
                desktopDropdown: {
                  placement: {
                    x: markerLeftPositionValue - dropdownPadding,
                    y: ctaTop + ctaHeight
                  },
                  width: dropdownWidth,
                  height: dropdownHeight,
                  asideHeight: dropdownAsideHeight
                }
              });
            } else {
              dispatch({
                type: ActionType.SET_NAVIGATION_ACTIVE,
                navigationIndex: index,
                markerLeftPosition: markerLeftPositionValue,
                desktopDropdown: null
              });
            }
          }
        }, isFirstAppear ? 0 : 125);
        timeoutRef.current = timeoutId;
      }
      if (onCtaMouseEnter && event) {
        onCtaMouseEnter(event);
      }
    };
  };
  var handleCtaMouseLeave = function handleCtaMouseLeave() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };
  var handleKeyOnDownElementWithDropdownDesktop = function handleKeyOnDownElementWithDropdownDesktop(index, event) {
    var isDropdownOpen = navigationIndex !== null && desktopDropdown !== null;
    if (event.key === KeyboardEventKeys.TAB && isDropdownOpen) {
      event.preventDefault();
      handleCtaMouseEnter(index)();
      if (isHugeScreen) {
        focusFirstElementInWrapper(dropdownRefs.current[index]);
      }
    }
    if (event.key === KeyboardEventKeys.ENTER && !isDropdownOpen) {
      handleCtaMouseEnter(index)();
    }
    if (event.key === KeyboardEventKeys.ENTER && isDropdownOpen) {
      dispatch({
        type: ActionType.SET_NAVIGATION_INACTIVE
      });
    }
    if (event.key === KeyboardEventKeys.ESC && isDropdownOpen) {
      dispatch({
        type: ActionType.SET_NAVIGATION_INACTIVE
      });
    }
  };
  var handleKeyOnDownElementWithDropdownMobile = function handleKeyOnDownElementWithDropdownMobile(index, event) {
    if (event.key === KeyboardEventKeys.ENTER) {
      handleCtaWithDropdownClick(index);
      focusFirstElementInWrapper(dropdownRefs.current[index], true);
    }
  };
  var handleKeyOnDownElementWithDropdown = function handleKeyOnDownElementWithDropdown(index, event) {
    if (isHugeScreen) {
      handleKeyOnDownElementWithDropdownDesktop(index, event);
    } else {
      handleKeyOnDownElementWithDropdownMobile(index, event);
    }
  };
  useEffect(function () {
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  useEffect(function () {
    setIsFirstAppear(navigationIndex === null);
  }, [navigationIndex]);
  useEffect(function () {
    if (navigationListFocusIndex !== null && ctaRefs.current[navigationListFocusIndex]) {
      focusFirstElementInWrapper(ctaRefs.current[navigationListFocusIndex]);
    }
  }, [navigationListFocusIndex]);
  var onColor = useContext(OnColorContext);
  var isDarkMode = useContext(IsDarkModeContext);
  var background = isDarkMode ? navigationBackgroundOnDarkMode : navigationBackgroundOnMobile;
  return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: isHugeScreen ? onColor : background
  }, /*#__PURE__*/React.createElement(NavigationList, _extends({
    $brand: brand,
    $markerLeftPosition: markerLeftPosition,
    $background: background
  }, restProps), ctaList.map(function (cta, index) {
    var hasTarget = !!cta.href || !!cta.to;
    return /*#__PURE__*/React.createElement("li", {
      onMouseEnter: function onMouseEnter(event) {
        return handleCtaMouseEnter(index, event)();
      },
      onMouseLeave: handleCtaMouseLeave,
      ref: function ref(_ref2) {
        if (_ref2) {
          ctaRefs.current[index] = _ref2;
        }
      },
      key: cta.text,
      "data-test-id": "menu-".concat(replaceSpaceToDashAndLowerCase(cta.text))
    }, !hasTarget && /*#__PURE__*/React.createElement(NavigationCtaAtm, {
      text: cta.text,
      isInactive: isNavigationCtaInactive(index),
      onClick: function onClick(event) {
        return handleCtaWithDropdownClick(index, event)();
      },
      onKeyDown: function onKeyDown(event) {
        return handleKeyOnDownElementWithDropdown(index, event);
      }
    }), hasTarget ? /*#__PURE__*/React.createElement(NavigationCtaAtm, {
      text: cta.text,
      href: cta.href,
      to: cta.to,
      title: cta.title,
      isInactive: isNavigationCtaInactive(index),
      onClick: function onClick(event) {
        return handleCtaWithoutDropdownClick(index, event)();
      }
    }) : null);
  }), backLink ? /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "huge"
  }, /*#__PURE__*/React.createElement(BackLinkLi, null, backLink)) : null));
}
export default NavigationListOrg;